import { request } from '@umijs/max';

// 获取退款记录分页列表
export async function getUserRefundPage({
  pageSize,
  current,
  filter,
  sorter,
}: {
  pageSize: number;
  current: number;
  filter: API.FormValues;
  sorter: string;
}) {
  return request('/api/admin/userRefund/page', {
    method: 'POST',
    data: {
      pageSize,
      current,
      filter,
      sorter,
      with: ['shop', 'operator', 'user', 'order', 'pay'],
    },
  });
}

// 获取退款详情
export async function getUserRefundInfo(values: API.FormValues) {
  return request('/api/admin/userRefund/info', {
    method: 'POST',
    data: {
      ...values,
      with: ['shop', 'operator', 'user', 'order', 'pay'],
    },
  });
}
